import $ from 'jquery'; // eslint-disable-line no-restricted-imports

// Fix next problem:
// If the user then moves to a different page and then clicks the Back button
// they get the data from the $.getJSON call displayed, not the page itself.
// https://stackoverflow.com/questions/2037295/getjson-back-button-showing-json-return-data-not-the-page
$.ajaxSetup({ cache: false });
